import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {Breadcrumb, Form, Segment, Header, Image, List, Button, Dimmer, Loader, Message} from 'semantic-ui-react'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import {
    fetchSprProductById,
    onSprModelBasicFieldChange,
    onSprModelDescriptionChange,
    onSprModelDataSheetChange,
    setSprProductModel
} from '../../actions/ecommerce'
import PropTypes from 'prop-types'
import Dls from '../../lib'
import { api } from '../../api'

const PARAGRAPH_HOLDER = require("../../assets/paragraph.png");

class SprProductEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            imageUpdating: false
        }
    }
    
    componentDidMount() {
        const {jwt} = this.props;
        const {id} = this.props.match.params;
        this.props.fetchSprProductById(jwt, id).catch(err => {
            Dls.apiErrorAlert(err);
        });
    }

    updateShopifyImage = () => {
        this.setState({
            imageUpdating: true
        }, () => {
            api.ecommerce.updateShopifyImage(this.props.jwt, this.props.model.id).then(res => {
                this.setState({
                    imageUpdating: false
                });
            }).catch(err => {
                Dls.apiErrorAlert(err);
                this.setState({
                    imageUpdating: false
                });
            })
        })
    }

    importFromSprManual = () => {
        this.setState({
            loading: true
        }, () => {
            api.ecommerce.manualImportFromSpr(this.props.jwt, this.props.model.id).then(res => {
                this.props.setSprProductModel(res.data.data);
                this.setState({
                    loading: false
                });
            }).catch(err => {
                Dls.apiErrorAlert(err);
                this.setState({
                    loading: false
                });
            })
        })
    }

    saveModel = () => {
        this.setState({
            loading: true
        });
        api.ecommerce.updateSprProductById(this.props.jwt, this.props.model).then(res => {
            this.setState({
                loading: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
            this.setState({
                loading: false
            });
        })
    }

    sprItemToSystemInventory = (id) => {
        this.setState({
            loading: true
        });
        api.ecommerce.sprItemToInventory(this.props.jwt, id).then(res => {
            const {data} = res.data;
            this.props.onSprModelBasicFieldChange('system_id', data);
            //console.log(data);
            this.setState({
                loading: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
            this.setState({
                loading: false
            });
        })
    }

    render() {
        const {model,     
            onSprModelBasicFieldChange,
            onSprModelDescriptionChange,
            onSprModelDataSheetChange} = this.props;
        return (
            <div>
                {!model.id ? <div className="row">
                    <div className="col-md-12">
                        <Segment>
                            <Dimmer active inverted>
                                <Loader content='Loading' />
                            </Dimmer>
                            <Image src={PARAGRAPH_HOLDER} />
                        </Segment>
                    </div>
                </div> : 
                    <div>
                        <div className="row">
                            <div className="col-md-12">
                                <Breadcrumb size="huge">
                                    <Breadcrumb.Section>
                                        SPR Product
                                    </Breadcrumb.Section>
                                </Breadcrumb>
                            </div>
                        </div>
                        <Form size='mini'>
                            <div className="row" style={{marginTop: '15px'}}>
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Segment>
                                                <Header as='h4'>Admin Operation (Do NOT change or modify)</Header>
                                                <Form.Group widths='equal'>
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="SPR ID"
                                                        name="spr_id"
                                                        value={model.spr_id ? model.spr_id : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="Shopify ID"
                                                        name="shopify_id"
                                                        value={model.shopify_id ? model.shopify_id : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="Shopify Variant ID"
                                                        name="system_id"
                                                        value={model.shopify_variant_id ? model.shopify_variant_id : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="System ID"
                                                        name="system_id"
                                                        value={model.system_id ? model.system_id : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                </Form.Group>
                                                <Header as='h4'>SRP Excel Data</Header>
                                                <Form.Group>
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        width={4}
                                                        readOnly
                                                        disabled={true}
                                                        label="Product SKU"
                                                        value={model.excel_sku}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        width={4}
                                                        name="excel_catalog_page"
                                                        label="Catalog Page"
                                                        value={model.excel_catalog_page}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        size='mini'
                                                        width={12}
                                                        fluid
                                                        name="excel_name"
                                                        label="Product Name"
                                                        value={model.excel_name}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                </Form.Group>
                                                <Form.Group widths='equal'>
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="DLS Category 1"
                                                        name="dls_category_1"
                                                        value={model.dls_category_1 ? model.dls_category_1 : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="DLS Category 2"
                                                        name="dls_category_2"
                                                        value={model.dls_category_2 ? model.dls_category_2 : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="DLS Category 3"
                                                        name="dls_category_3"
                                                        value={model.dls_category_3 ? model.dls_category_3 : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="DLS Category 4 (Best Seller)"
                                                        name="dls_category_4"
                                                        value={model.dls_category_4 ? model.dls_category_4 : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                </Form.Group>
                                                <Form.Group widths='equal'>
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="UOM"
                                                        name="excel_uom"
                                                        value={model.excel_uom}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="UPC"
                                                        name="excel_upc"
                                                        value={model.excel_upc}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="DLS Cost"
                                                        name="excel_dls_cost"
                                                        value={model.excel_dls_cost}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="DLS Price"
                                                        name="excel_dls_sell"
                                                        value={model.excel_dls_sell}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        size='mini'
                                                        label="MSRP"
                                                        name="excel_spr_msrp"
                                                        value={model.excel_spr_msrp}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                </Form.Group>
                                                <Header as='h4'>SRP Data Feed (Overwritten when upload)</Header>
                                                <Form.Group widths='equal'>
                                                    <Form.Input
                                                        fluid
                                                        label="Manufacturer"
                                                        name="srp_manufacturer"
                                                        value={model.srp_manufacturer ? model.srp_manufacturer : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Input
                                                        fluid
                                                        label="Category"
                                                        name="srp_category"
                                                        value={model.srp_category ? model.srp_category : ""}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange(e.target.name, value);
                                                        }}
                                                    />
                                                    <Form.Select
                                                        options={[
                                                            {value: 'Active', text: 'Active'},
                                                            {value: 'Discontinued', text: 'Discontinued'}
                                                        ]}
                                                        label='Item Status'
                                                        name='latest_spr_status'
                                                        value={model.latest_spr_status}
                                                        onChange={(e, {value}) => {
                                                            onSprModelBasicFieldChange('latest_spr_status', value)
                                                        }}
                                                    />
                                                </Form.Group>
                                                <Form.Group>
                                                    <Form.Checkbox 
                                                        label="Shopiy Update: Export Selling Price ONLY"
                                                        checked={model.shopify_price_only}
                                                        onChange={(e, data) => {
                                                            onSprModelBasicFieldChange('shopify_price_only', !model.shopify_price_only)
                                                        }}
                                                    />
                                                </Form.Group>
                                                <Form.Group>
                                                    <Form.Checkbox 
                                                        label="Shopiy Update: DO NOT update Shopify at all (this will overwrite above checkbox)"
                                                        checked={model.lock}
                                                        onChange={(e, data) => {
                                                            onSprModelBasicFieldChange('lock', !model.lock)
                                                        }}
                                                    />
                                                </Form.Group>
                                                <div style={{marginTop: '15px'}}>
                                                    <Button color='teal' size='mini'
                                                        onClick={() => {
                                                            this.saveModel()
                                                        }}
                                                        loading={this.state.loading}
                                                        disabled={this.state.disabled}
                                                    >Save</Button>
                                                </div>
                                            </Segment>
                                        </div>
                                    </div>

                                    <div className="row" style={{marginTop: '15px'}}>
                                        <div className="col-md-12">
                                            <Segment>
                                                <Header as='h4'>SRP Data Feed - Basic Information & Description</Header>
                                                
                                                {/* {_.isObject(model.spr_description) ? Object.keys(model.spr_description).map((key) => {
                                                    if (key !== '@attributes') {
                                                        return <Form.Input 
                                                            size='mini'
                                                            fluid
                                                            name={`spr_description_${key}`}
                                                            value={model.spr_description[key]}
                                                            key={key}
                                                            onChange={(e, {value}) => {
                                                                onSprModelDescriptionChange(key, value)
                                                            }}
                                                        />
                                                    }
                                                }) : null} */}
                                                <List>
                                                    {_.isObject(model.spr_description) ? Object.keys(model.spr_description).map((key) => {
                                                        if (key !== '@attributes') {
                                                            return <List.Item key={key}>
                                                                {model.spr_description[key]}
                                                            </List.Item>
                                                        }
                                                    }) : null}
                                                </List>
                                            </Segment>
                                        </div>
                                    </div>

                                    {model.spr_data_sheet ? <div className="row" style={{marginTop: '15px'}}>
                                        <div className="col-md-12">
                                            <Segment>
                                                {/* {Object.keys(model.spr_data_sheet).map(key => {
                                                    return <div key={key} style={{marginTop: 15}}>
                                                        <Header as='h4'>SPR Data Sheet - {key}</Header>
                                                        {Object.keys(model.spr_data_sheet[key]).map(k => {
                                                            if (k === '@attributes') {
                                                                return <p key={k}>
                                                                    {model.spr_data_sheet[key][k].name}
                                                                </p>
                                                            }
                                                        })}
                                                        {Object.keys(model.spr_data_sheet[key]).map(k => {
                                                            if (k !== '@attributes') {
                                                                return <Form.Input 
                                                                    size='mini'
                                                                    fluid
                                                                    name={`spr_datasheet_${key}_${k}`}
                                                                    value={model.spr_data_sheet[key][k]}
                                                                    key={k}
                                                                    onChange={(e, {value}) => {
                                                                        onSprModelDataSheetChange(key, k, value)
                                                                    }}
                                                                />
                                                            }
                                                        })}
                                                    </div>
                                                })} */}
                                                {Object.keys(model.spr_data_sheet).map(key => {
                                                    return <div key={key} style={{marginTop: 15}}>
                                                        <Header as='h4'>SPR Data Sheet - {key}</Header>
                                                        <List>
                                                            {Object.keys(model.spr_data_sheet[key]).map(k => {
                                                                if (k === '@attributes') {
                                                                    return <p key={k}>
                                                                        {model.spr_data_sheet[key][k].name}
                                                                    </p>
                                                                }
                                                            })}
                                                            {Object.keys(model.spr_data_sheet[key]).map(k => {
                                                                if (k !== '@attributes') {
                                                                    return <List.Item key={k}>
                                                                        {model.spr_data_sheet[key][k]}
                                                                    </List.Item>
                                                                }
                                                            })}
                                                        </List>
                                                    </div>
                                                })}
                                            </Segment>
                                        </div>
                                    </div> : null}
                                </div>
                                <div className="col-md-4">
                                    <Segment>
                                        <Header as='h4'>Data Sync</Header>
                                        <List>
                                            <List.Item>
                                                SPR Product ID: {model.spr_id}
                                            </List.Item>
                                            <List.Item>
                                                Shopify ID: {model.shopify_id > 0 ? model.shopify_id : "No"}
                                            </List.Item>
                                            {/* <List.Item>
                                                Manual Update Shopify: <Button
                                                    size='mini'
                                                    color='teal'
                                                    onClick={() => {

                                                    }}
                                                    loading={this.state.loading}
                                                    disabled={this.state.disabled}
                                                >Update</Button>
                                            </List.Item> */}
                                            <List.Item>
                                                Inventory ID: {model.system_id > 0 ? 
                                                    <Link to={`/inventories/${model.system_id}/view`}>{model.system_id}</Link> : <Button
                                                        size='mini' color='teal' onClick={() => {
                                                            this.sprItemToSystemInventory(model.id)
                                                        }}
                                                        loading={this.state.loading}
                                                        disabled={this.state.loading}
                                                    >Create</Button>}
                                            </List.Item>
                                            <List.Item>
                                                SPR Status: {model.latest_spr_status}
                                            </List.Item>
                                        </List>
                                    </Segment>
                                    <Segment>
                                        <Header as='h4'>Product Image</Header>
                                        {_.isArray(model.spr_images) ? <Carousel showThumbs={false}>
                                            {model.spr_images.map(img => {
                                                return <div key={img.type}>
                                                    <img src={`${img.url}`} />
                                                    <p className="legend">Type: {img.type}</p>
                                                </div>
                                            })}
                                        </Carousel> : null}
                                        {model.shopify_id > 0 ? <div style={{marginTop: "5px"}}>
                                            <Button size='mini' color='teal'
                                                disabled={this.state.imageUpdating}
                                                loading={this.state.imageUpdating}
                                                onClick={() => {
                                                    this.updateShopifyImage();
                                                }}
                                            >Update Shopify Images</Button>
                                        </div> : null}
                                    </Segment>
                                    <Segment>
                                        <Header as='h4'>Product Image</Header>
                                        <Message info>
                                            <Header as='h4'>Updating Rules</Header>
                                            <List>
                                                <List.Item>
                                                    All SPR fields, including manufacturer, cateogory and images will be overwritten 
                                                    every month after you upload a new pricing file.
                                                </List.Item>
                                                <List.Item>
                                                    A very small amount of items (~0.2 % of new items) cannot be imported from SPR due to the limitation of 
                                                    our search methods. In such case, you may want to manualy find the item on ItemInfo and update 
                                                    the SPR ID field. Lastly, click <Button 
                                                        size='mini' color='teal'
                                                        loading={this.state.loading}
                                                        disabled={this.state.loading}
                                                        onClick={() => {
                                                            this.importFromSprManual()
                                                        }}>Here</Button> to import from SPR.
                                                </List.Item>
                                                <List.Item>
                                                    There's a script running in the back-ground. If you update this item by clicking on 
                                                    "Save" button, the script will also update Shopify store in the next few minutes.
                                                </List.Item>
                                                <List.Item>
                                                    UPDATE Shopify will NOT include images.
                                                </List.Item>
                                            </List>
                                        </Message>
                                    </Segment>
                                </div>
                            </div>
                        </Form>
                    </div>
                }
            </div>
        )
    }
}

SprProductEdit.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    fetchSprProductById: PropTypes.func.isRequired,
    onSprModelBasicFieldChange: PropTypes.func.isRequired,
    onSprModelDescriptionChange: PropTypes.func.isRequired,
    onSprModelDataSheetChange: PropTypes.func.isRequired,
    setSprProductModel: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        model: state.ecommerce.sprModel
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchSprProductById,
        onSprModelBasicFieldChange,
        onSprModelDescriptionChange,
        onSprModelDataSheetChange,
        setSprProductModel
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SprProductEdit)


// WEBPACK FOOTER //
// ./src/components/ecommerce/SprProductEdit.js